import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './components/Auth/Login';
import SaaSAdminLayout from './components/Layout/SaaSAdminLayout';
import { AuthProvider, useAuth } from './context/AuthContext';
import { isTenantRequest } from './utils/cnameRouting';

// Dashboard
import SaaSDashboard from './components/Dashboard/SaaSDashboard';

// Tenants
import TenantCreate from './components/Tenants/TenantCreate';
import TenantDetail from './components/Tenants/TenantDetail';
import TenantEdit from './components/Tenants/TenantEdit';
import TenantList from './components/Tenants/TenantList';

// Theme
import ThemeConfig from './components/Theme/ThemeConfig';

// Modules
import ModuleRegistry from './components/Modules/ModuleRegistry';
import ModuleUsage from './components/Modules/ModuleUsage';

// Analytics
import PlatformAnalytics from './components/Analytics/PlatformAnalytics';

// Billing
import Plans from './components/Billing/Plans';
import Subscriptions from './components/Billing/Subscriptions';

// Settings
import PlatformSettings from './components/Settings/PlatformSettings';

import './App.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const isTenant = isTenantRequest();
  
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // If accessing via tenant subdomain (shilpani.bigfat.ai)
  if (isTenant) {
    // For tenant mode, allow admin and user roles
    if (!['admin', 'user'].includes(user?.role)) {
      return <Navigate to="/login" />;
    }
  } else {
    // For platform mode (bigfat.ai), only allow superadmin
    if (user?.role !== 'superadmin') {
      return <Navigate to="/login" />;
    }
  }
  
  return children;
};

// Component to display current tenant info
// const TenantInfo = () => {
//   const currentTenant = getCurrentTenant();
//   const isTenant = isTenantRequest();
  
//   if (!isTenant || !currentTenant) return null;
  
//   return (
//     <div style={{ 
//       background: '#f8f9fa', 
//       padding: '10px 20px', 
//       borderBottom: '1px solid #dee2e6',
//       textAlign: 'center'
//     }}>
//       <small style={{ color: '#6c757d' }}>
//         Viewing as: <strong>{currentTenant}</strong>
//       </small>
//     </div>
//   );
// };

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          {/* <TenantInfo /> */}
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <SaaSAdminLayout />
                </PrivateRoute>
              }
            >
              <Route index element={<SaaSDashboard />} />
              
              {/* Tenants Management */}
              <Route path="tenants" element={<TenantList />} />
              <Route path="tenants/new" element={<TenantCreate />} />
              <Route path="tenants/:id" element={<TenantDetail />} />
              <Route path="tenants/:id/edit" element={<TenantEdit />} />
              <Route path="tenants/:id/theme" element={<ThemeConfig />} />
              
              {/* Modules Management */}
              <Route path="modules" element={<ModuleRegistry />} />
              <Route path="modules/usage" element={<ModuleUsage />} />
              
              {/* Analytics */}
              <Route path="analytics" element={<PlatformAnalytics />} />
              
              {/* Billing */}
              <Route path="billing" element={<Navigate to="/billing/plans" replace />} />
              <Route path="billing/plans" element={<Plans />} />
              <Route path="billing/subscriptions" element={<Subscriptions />} />
              
              {/* Settings */}
              <Route path="settings" element={<PlatformSettings />} />
            </Route>
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

